import "./components/utility/suppressWarnings";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import LandingPage from "./components/LandingPage";
import "./i18n";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<LandingPage />);
